import {Link} from "react-router-dom";
import useSidebar from "../../Shared/Sidebar/useSidebar";
import {Sidebar} from "../../Shared/Sidebar/Sidebar";

const {Pane, Menu} = require("evergreen-ui");
const React = require("react");

function OperationsSidebar() {
    const {isPinned, isHide, onChangeHide, onChangePinned} = useSidebar();
    return (
        <Sidebar
            isPinned={isPinned}
            isHide={isHide}
            onClickHide={onChangeHide}
            onClickPin={onChangePinned}
            title="Дополнительные расчеты"
            width={400}
            containerStyles={{
                display: 'grid',
                padding: '.5rem',
            }}
        >
            <Pane
                backgroundColor="#fff"
            >
                <Menu>
                    <Menu.Group>
                        <Menu.Item is={Link} to="sensor-deviation">
                            Отклонения показаний датчиков
                        </Menu.Item>
                        <Menu.Divider />
                    </Menu.Group>
                </Menu>
            </Pane>
        </Sidebar>
    );
}

export default function OperationsSidebarWrapper() {
    return <OperationsSidebar/>;
}